import React from 'react';
import { Link } from 'react-router-dom';
import '../../assets/styles/authentication/auth.css';

const AuthLayout = ({ children, title, subtitle, linkText, linkTo, LeftImage, Logo }) => {
  return (
    <div className='container-fluid auth-layout vh-100'>
      <div className='row h-100'>
        {/* Left Section */}
        <div className='col-md-6 d-none d-md-flex auth-layout-left'>
          {Logo && <img src={Logo} alt='Logo' className='auth-logo' />}
          <h2 className='outfit-bold mb-3'>Welcome to Comniq AI</h2>
          <p className='outfit-medium text-muted mb-4 px-4'>
            Comniq AI helps businesses simplify customer interactions and boost productivity with intelligent automation solutions.
          </p>
          {LeftImage && <img src={LeftImage} alt='Dashboard' className='img-fluid auth-mockup-img' />}
        </div>

        {/* Right Section */}
        <div className='col-md-6 auth-layout-right'>
          <div className='auth-form'>
            <div className='mb-4'>
              {title && <h2 className={`outfit-bold ${title === 'Verify your account' ? 'text-center' : ''}`}>{title}</h2>}
              {subtitle && (
                <p className='outfit-medium mb-0'>
                  {subtitle}{' '}
                  {linkText && linkTo && (
                    <Link to={linkTo} className='auth-link outfit-bold'>
                      {linkText}
                    </Link>
                  )}
                </p>
              )}
            </div>

            {/* Page-specific form */}
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
